import { httpRequest } from "../base/httpRequest";

const CLAIM_URL = `/api/payclaim/account/accId`;
const BASE_URL = `/api/claim/account/accId/contract_group`;
const CONTRACT_URL = `/api/contract/account/accId/contract_group`;

const sign_up = (data, params) =>
  httpRequest(
    "post",
    `/auth/invite/guest`,
    data,
    params ? { params } : undefined,
  );

//* account details
const upload_account_avatar = (data) =>
  httpRequest(
    "post",
    `${CLAIM_URL}/avatar`,
    data,
    {},
    { "Content-Type": "multipart/form-data" },
  );

const read_account_cert_reason = () =>
  httpRequest("get", `${CLAIM_URL}/reasons`); //reason
//* dashboard

const read_active_projects = (params) =>
  httpRequest("get", `${CLAIM_URL}/dashboard/active/contracts`, null, {
    params,
  }); //result

const read_projects_summary = (params) =>
  httpRequest("get", `${CLAIM_URL}/contractlist?`, null, { params }); //contractlist

const read_upcoming_cert_summary = (params) =>
  httpRequest("get", `${CLAIM_URL}/dashboard/upcoming/cert/summary?`, null, {
    params,
  }); //result

const read_retention_summary = (params) =>
  httpRequest("get", `${CLAIM_URL}/dashboard/retention/summary`, null, {
    params,
  }); //result

const read_cert_claim_list = (data) =>
  httpRequest("post", `${CLAIM_URL}/search/claims/certs`, data); //result

// * manage account
const read_user_profile = () => httpRequest("get", `${CLAIM_URL}/getuser`);

const update_user_profile = (data) =>
  httpRequest("put", `${CLAIM_URL}/updateuser`, data); //result

const set_user_email_preference = (data) =>
  httpRequest("put", `${CLAIM_URL}/user/email/preferences`, data);

const read_email_notice_time = () =>
  httpRequest("get", `${CLAIM_URL}/summary_email_time`);

const update_email_notice_time = (data) =>
  httpRequest("put", `${CLAIM_URL}/summary_email_time`, data);

const download_one_file = (fileId, config) =>
  httpRequest("get", `${CLAIM_URL}/file/${fileId}`, null, config); //blob

const download_one_shared_file = (url, config) =>
  httpRequest("get", url, null, config); //blob

const download_one_shared_file_by_token = (token, config) =>
  httpRequest(
    "get",
    `/api/payclaim/file/token/${token}/download`,
    null,
    config,
  ); //blob

// * contract summary
const read_contract_summary = (proId, contractId) =>
  httpRequest("get", `${CONTRACT_URL}/${proId}/contract/${contractId}/summary`); //contractsummary

// * claim payment record
const read_payment_history = (proId, contractId) =>
  httpRequest(
    "get",
    `${CLAIM_URL}/contract_group/${proId}/contract/${contractId}/payment-history`,
  ); //data

const create_claim_payment = (proId, contractId, claimId, data) =>
  httpRequest(
    "post",
    `${CLAIM_URL}/contract_group/${proId}/contract/${contractId}/claim/${claimId}/payment-history/exec`,
    data,
    {},
    { "Content-Type": "multipart/form-data" },
  );

//*notice
const read_all_notice = () => httpRequest("get", `${CLAIM_URL}/notifications`); //notification
const read_notice_num = () =>
  httpRequest("get", `${CLAIM_URL}/notifications/num`); //note nums

const read_setup_process = () =>
  httpRequest("get", `${CLAIM_URL}/started/process`); //result

//*claim summary
const read_claim_summary = (data, params) =>
  httpRequest("post", `${CLAIM_URL}/claimsummary`, data, { params }); //claimsummary

const read_one_claim = (proId, contractId, claimId) =>
  httpRequest(
    "get",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}`,
  ); //readpayclaim

const read_contract_claim_period = (proId, contractId, params) =>
  httpRequest(
    "get",
    `${BASE_URL}/${proId}/contract/${contractId}/claimperiod`,
    null,
    {
      params,
    },
  ); //data

const read_claim_net_cert = (proId, contractId, date) =>
  httpRequest(
    "get",
    `${CLAIM_URL}/contract_group/${proId}/contract/${contractId}/cert_to_date?date=${date}`,
  );

const read_claim_notify = (proId, contractId, claimId) =>
  httpRequest(
    "get",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/issue/auto_notify`,
  );

const create_one_claim = (proId, contractId) =>
  httpRequest("post", `${BASE_URL}/${proId}/contract/${contractId}/claim`);

const update_one_claim = (proId, contractId, claimId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}`,
    data,
  );

const delete_one_claim = (proId, contractId, claimId) =>
  httpRequest(
    "delete",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}`,
  );

const send_approval_one_claim = (proId, contractId, claimId, body = {}) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/review`,
    body,
  );

const revert_claim_to_review = (proId, contractId, claimId, body = {}) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/back/review`,
    body,
  );

const approve_one_claim = (proId, contractId, claimId) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/approve`,
  );

const upload_file_claim = (proId, contractId, claimId, data, config) =>
  httpRequest(
    "post",
    `${CLAIM_URL}/contract_group/${proId}/contract/${contractId}/claim/${claimId}/upload`,
    data,
    config,
    { "Content-Type": "multipart/form-data" },
  );

const delete_file_claim = (proId, contractId, fileId) =>
  httpRequest(
    "delete",
    `${CLAIM_URL}/contract_group/${proId}/contract/${contractId}/doc/${fileId}/delete`,
  );

const update_claim_shared_attachment = (proId, contractId, claim_id, data) =>
  httpRequest(
    "post",
    `${CLAIM_URL}/contract_group/${proId}/contract/${contractId}/claim/${claim_id}/shared`,
    data,
  );

// * send payclaim email when issue
const send_payclaim_email = (proId, contractId, claimId, data) =>
  httpRequest(
    "post",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/email`,
    data,
  );

const download_claim_pdf = (proId, contractId, claimId, config) =>
  httpRequest(
    "get",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/pdf`,
    null,
    config,
  );

const issue_one_claim = (proId, contractId, claimId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/issue`,
    data,
  );

const issue_one_claim_integration = (proId, contractId, claimId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/integration/issue`,
    data,
  );

const revert_claim_to_draft = (proId, contractId, claimId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/back/draft`,
    data,
  );

// * claim patch update
const update_claim_info = (proId, contractId, claim_id, data) =>
  httpRequest(
    "patch",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claim_id}`,
    data,
  );

const read_claim_workflow = (proId, contractId, claimId) =>
  httpRequest(
    "get",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/workflow`,
  ); //data

const update_claim_workflow = (proId, contractId, claimId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/workflow`,
    data,
  ); //workflow

const approve_claim_step = (proId, contractId, claimId, stepId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/workflow/${stepId}/approve`,
    data,
  );
const revert_claim_workflow = (proId, contractId, claimId, stepId, data) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/workflow/${stepId}/revert`,
    data,
  ); //data

const create_one_claim_lineitem = (proId, contractId, claimId, config, data) =>
  httpRequest(
    "post",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/item`,
    data,
    config,
    { "Content-Type": "multipart/form-data" },
  );

const delete_one_claim_lineitem = (proId, contractId, claimId, lineItemId) =>
  httpRequest(
    "delete",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/lineitem/${lineItemId}`,
  );

const create_xero_invoice = (proId, contractId, claimId) =>
  httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/xero/invoice`,
  );

const link_claim_xero_invoice = (
  proId,
  contractId,
  claimId,
  invoiceId,
  data,
) => {
  return httpRequest(
    "post",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/link/xero/invoice?invoice_id=${invoiceId}`,
    data,
  );
};

const update_xero_invoice_settings = (
  proId,
  contractId,
  claimId,
  invoiceId,
  data,
) => {
  return httpRequest(
    "patch",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/xero/invoice?invoice_id=${invoiceId}`,
    data,
  );
};

const get_xero_last_updated_dates = (proId, contractId, claimId) => {
  return httpRequest(
    "get",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/xero/invoices/last_updated`,
  );
};

const delete_xero_invoice_link = (proId, contractId, claimId, invoiceId) => {
  return httpRequest(
    "delete",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/link/xero/invoice?invoice_id=${invoiceId}`,
  );
};

const attach_claim_to_invoice = (proId, contractId, claimId, invoiceId) => {
  return httpRequest(
    "put",
    `${BASE_URL}/${proId}/contract/${contractId}/claim/${claimId}/xero/upload?invoice_id=${invoiceId}`,
  );
};

export default {
  sign_up,
  // * profile
  upload_account_avatar,
  // *  account
  read_account_cert_reason,
  // * dashboard
  read_active_projects,
  read_projects_summary,
  read_upcoming_cert_summary,
  read_retention_summary,
  read_cert_claim_list,
  // * account
  read_user_profile,
  update_user_profile,
  set_user_email_preference,
  read_email_notice_time,
  update_email_notice_time,
  // * file
  download_one_file,
  download_one_shared_file,
  download_one_shared_file_by_token,
  // * contract summary
  read_contract_summary,
  // * payment claim
  read_payment_history,
  create_claim_payment,
  // * notice
  read_all_notice,
  read_notice_num,
  read_setup_process,
  // * claim summary
  read_claim_summary,
  // * make a claim
  read_one_claim,
  read_claim_notify,
  approve_one_claim,
  send_approval_one_claim,
  revert_claim_to_review,
  update_one_claim,
  create_one_claim,
  delete_one_claim,
  read_contract_claim_period,
  read_claim_net_cert,

  upload_file_claim,
  delete_file_claim,
  update_claim_shared_attachment,

  // * send email
  send_payclaim_email,
  // *  make a cert
  download_claim_pdf,

  // * new apis
  revert_claim_to_draft,
  update_claim_info,
  issue_one_claim,
  issue_one_claim_integration,
  update_claim_workflow,
  approve_claim_step,
  read_claim_workflow,
  revert_claim_workflow,
  create_one_claim_lineitem,
  delete_one_claim_lineitem,

  // xero apis
  create_xero_invoice,
  link_claim_xero_invoice,
  update_xero_invoice_settings,
  delete_xero_invoice_link,
  attach_claim_to_invoice,
  get_xero_last_updated_dates,
};
